import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';
import { Skeleton, SkeletonStatus } from 'common/components';

export const LoginEmbeddedSkeleton = () => {
  const { t } = useTranslation('common', { keyPrefix: 'loading' });
  return (
    <>
      <SkeletonStatus label={t('openingYourSignInPage')} />
      <Stack gap={2} bgcolor="common.white" data-testid="login-embedded-skeleton">
        <Skeleton variant="rounded" height={48} />
        <Skeleton variant="rounded" height={48} />
        <Stack direction="row" justifyContent="space-between">
          <Skeleton width={125} />
          <Skeleton width={120} />
        </Stack>

        <Skeleton variant="rounded" height={40} className="mt-4" />
      </Stack>
    </>
  );
};
